import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "p",
  props: {
    text: {
      prop: "other",
      type: "textarea",
      value: "Paragraph text",
    },
    paragraphStyle: {
      prop: "other",
      type: "select",
      value: "p1",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        /** @TODO Get font family back in here out we decide the options for it. */
        textTransform: getTextTransformOptions(defaultStyles.textTransform),
        fontStyle: getFontStyleOptions(defaultStyles.fontStyle),
        fontSize: getFontSizeOptions(defaultStyles.fontSize),
        textAlign: getTextAlignOptions(defaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(defaultStyles.textDecoration),
        lineHeight: getLineHeightOptions(defaultStyles.lineHeight),
        color: getColorOptions(defaultStyles.color),
        fontWeight: getFontWeightOptions(defaultStyles.fontWeight),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
      },
    },
  },
};
